<ng-container>
    <p-menu class="custom-menu" [model]="menuItems" [popup]="true" #menu></p-menu>
</ng-container>

<app-custom-instructions-dialog [showdialog]="displayCustomInstructions"
    (emitSummaryForDoc)="submitInstructions($event)" (closeDialog)="closeDialog($event)">
</app-custom-instructions-dialog>

<ng-template availableFor [isAdminPage]="true">
    <app-prompt-library-dialog [showdialog]="displayPromptLibrary" (closeDialog)="closePromptLibraryDialog($event)">
    </app-prompt-library-dialog>
</ng-template>

<ng-template availableFor [isAdminPage]="true">
    <app-usage-stats (visibleChange)="toggleUsageStats($event)" [visible]="showUsageStats"></app-usage-stats>
</ng-template>